import { render, staticRenderFns } from "./confirmlistdatacomponents.vue?vue&type=template&id=1ad79c76"
import script from "./confirmlistdatacomponents.vue?vue&type=script&lang=js"
export * from "./confirmlistdatacomponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports